<script setup>
// NOTICE: KAPTION-INTEGRATION
// call-transcript-search.WEB.4 — the "Call transcripts" group in the global
// conversation search: up to 3 calls (`call_results`, GLOBAL.1), one snippet
// each with its time chip, and "See all in Calls" carrying the query over.
// A row opens the call detail; the chip opens it playing from that second.
import { useRoute, useRouter } from 'vue-router';
import { frontendURL } from 'dashboard/helper/URLHelper';
import KaptionCallSearchResult from './KaptionCallSearchResult.vue';
import { TRANSCRIPT_ACCENT, TRANSCRIPT_ICON } from './kaptionCallPaper';

const props = defineProps({
  results: { type: Array, default: () => [] },
  query: { type: String, default: '' },
});

const route = useRoute();
const router = useRouter();

const callsPath = () =>
  frontendURL(`accounts/${route.params.accountId}/calls/all`);

const open = hit =>
  router.push({
    path: callsPath(),
    query: { call: hit.callId, q: props.query },
  });
const jump = (hit, ms) =>
  router.push({
    path: callsPath(),
    query: { call: hit.callId, t: String(ms), q: props.query },
  });
const seeAll = () =>
  router.push({ path: callsPath(), query: { q: props.query } });
</script>

<template>
  <section
    data-testid="kaption-call-search-group"
    class="border-b border-n-weak pb-1"
  >
    <header class="flex items-center justify-between gap-2 px-4 pb-1.5 pt-3">
      <span
        class="flex items-center gap-1.5 text-[11px] font-medium uppercase leading-none tracking-[0.08em] text-n-slate-10"
      >
        <span class="size-3.5" :class="[TRANSCRIPT_ICON, TRANSCRIPT_ACCENT]" />
        {{ $t('KAPTION_CALLS.SEARCH.GLOBAL_GROUP') }}
      </span>
      <button
        type="button"
        data-testid="kaption-call-search-see-all"
        class="flex items-center gap-0.5 text-xs font-medium text-n-slate-11 hover:text-n-slate-12"
        @click="seeAll"
      >
        {{ $t('KAPTION_CALLS.SEARCH.SEE_ALL') }}
        <span class="i-lucide-arrow-right size-3" />
      </button>
    </header>
    <div
      v-for="result in results.slice(0, 3)"
      :key="result.call?.id"
      class="px-4 py-2 transition-colors hover:bg-n-alpha-1"
    >
      <KaptionCallSearchResult
        :result="result"
        compact
        @open="open"
        @jump="jump"
      />
    </div>
  </section>
</template>
